import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createTenantLanguage, fetchTenantInvoiceDetails, fetchTenantLanguages, removeTenantLanguage, updateTenantLanguage } from "../app/actions";

import { Button, Table } from "react-bootstrap"
import AddEditTenantLanguageModal from "./AddEditTenantLanguageModal";


const TenantLanguages = ({tenant}) => {
    const [editTenantLanguage, setEditTenantLanguage] = useState(null)
    const [showAddEditModal, setShowAddEditModal] = useState(false)
    const loadingTenantLanguages = useSelector(store => store.app.loadingTenantLanguages);
    const tenantLanguages = useSelector(store => store.app.tenantLanguages);
    const dispatch = useDispatch();
    useEffect(()=>{
        loadLanguages()
    }, [])

    const loadLanguages = () => {
        dispatch(fetchTenantLanguages("", {TenantID: tenant}))
        dispatch(fetchTenantInvoiceDetails(tenant))
    }

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleDelete = (tenantLanguage) => {
        if(tenantLanguage.id) {
            dispatch(removeTenantLanguage(tenantLanguage.id))
                .then(()=>{
                    loadLanguages()
                    setShowAddEditModal(false)
                })
        }
    }

    const handleSave = (tenantLanguage) => {
        if(tenantLanguage.id) {
            dispatch(updateTenantLanguage(
                tenantLanguage.id,
                tenant,
                tenantLanguage.LanguageID
            )).then(()=>{
                loadLanguages()
                setShowAddEditModal(false)
            })
        } else {
            dispatch(createTenantLanguage(
                tenant,
                tenantLanguage.LanguageID
            )).then(()=>{
                loadLanguages()
                setShowAddEditModal(false)
            })
        }
    }
    
    return <div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h5>Languages</h5>
            <Button onClick={()=>{
                setEditTenantLanguage(null);
                setShowAddEditModal(true);
            }}>Add language</Button>
        </div>
        <br/>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Language ID</th>
                    <th>Iso Language</th>
                    <th>Language Description</th>
                    <th>Updated</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {!loadingTenantLanguages && tenantLanguages && tenantLanguages.map(tenantLanguage => {
                    return <tr key={tenantLanguage.id} onClick={()=>{
                        setShowAddEditModal(true)
                        setEditTenantLanguage(tenantLanguage)
                    }}>
                        <td>{tenantLanguage.id}</td>
                        <td>{tenantLanguage.LanguageID}</td>
                        <td>{tenantLanguage.IsoLanguage}</td>
                        <td>{tenantLanguage.Description}</td>
                        <td>{tenantLanguage.updated_at}</td>
                        <td>{tenantLanguage.created_at}</td>
                    </tr>
                })}
                
            </tbody>
        </Table>
        <AddEditTenantLanguageModal editTenantLanguage={editTenantLanguage} show={showAddEditModal} onHide={hideAddEditModal} onSave={handleSave} onDelete={handleDelete}/>
    </div>
} 

export default TenantLanguages